import { getLocalizedOrDefault } from "../../../helpers/Functions";
const FindByFeaturesPageConfig = {
  collection: "find_by_features_page",
  fields: [
    "id",
    "selected_features.attribute.id",
    "selected_features.label_override",
    "selected_types",

    "product_layout",
    "selected_products.products_id.id",
    "locale.languages_code.code",

    "locale.heading",
    "locale.subheading",
    "locale.term_primary",
    "locale.term_secondary",
    "locale.clear_filters",
    //scanners
    "locale.language",
    "heading_color",
    "selected_features.specification.id"
  ],

  single: true,

  adapter: class FindByFeatures {
    // Layer #1
    constructor(find_by_features) {
      this.id = find_by_features.id;

      this.html_id = `find-by-features-${this.id}`;
      this.heading_color = find_by_features.heading_color || "";

      this.product_layout = find_by_features.product_layout || "8-columns";
      // Number of text lines for product tiles
      this.product_title_lines = 2; //3;
      this.selected_products = (find_by_features.selected_products || []).map(
        (product) => product?.products_id?.id
      );
      this.selected_features = (find_by_features.selected_features || []).map(
        (feature) => ({
          label: feature.label_override,
          attribute: feature.attribute?.id || feature.specification?.id
        })
      );

      let locale = find_by_features.locale?.[0];
      if (!locale) return;
      this.locale = find_by_features.locale;
      this.heading = locale.heading;
      this.subheading = locale.subheading;
      this.term_primary = locale.term_primary;
      this.term_secondary = locale.term_secondary;
      this.clear_filters = locale.clear_filters;
    }

    // Layer #2
    map(collections, maps) {
      this.selected_products = this.selected_products
        .map((selected_product_id) => maps.products[selected_product_id])
        // retain valid products
        .filter((p) => !!p);
      //get products in the order of their type for better for find by features on pdf to work
      this.selected_types = [
        ...new Set(
          this.selected_products.map(
            (product) => maps.product_types[product.product_type]
          )
        )
      ];
      this.selected_products = this.selected_types.flatMap((selected_type) =>
        this.selected_products.filter((product) => {
          const product_type = product.product_type?.id || product.product_type;
          return product_type === selected_type?.id;
        })
      );

      this.selected_features = this.selected_features.map(
        (selected_feature) => ({
          label: selected_feature.label,
          attribute:
            maps.attributes[
              selected_feature.attribute || selected_feature.specification
            ]
        })
      );

      this.locale = this.locale.map(
        ({ languages_code, language, ...other_props }) => ({
          ...other_props,
          language:
            maps.languages?.[languages_code.code] || maps.locales[language]
        })
      );

      const { global_settings } = collections;
      const { default_locale } = global_settings;

      // e.g. field_name: header
      //      selected_locale: 'es-CL'
      this.getLocalized = (field_name, selected_locale) => {
        return getLocalizedOrDefault(
          this,
          field_name,
          { locale: selected_locale },
          { locale: default_locale }
        );
      };
    }
  }
};

export default FindByFeaturesPageConfig;
